interface ICurrency {
  badge(): string;
  decimals(): number;
}

export class Currency implements ICurrency {
  key: CurrencyKey;

  constructor(key: CurrencyKey) {
    this.key = key;
  }

  public decimals(): number {
    return CURRENCIES_DATA[this.key].decimals;
  }

  public badge(): string {
    return CurrencyBadge[this.key];
  }
}

const CURRENCIES_DATA: Record<CurrencyKey, CurrencyValue> = {
  EUR: { decimals: 2 },
  USD: { decimals: 2 },
  MXN: { decimals: 2 },
  COP: { decimals: 2 },
  BRL: { decimals: 2 },
  PEN: { decimals: 2 },
};

export type CurrencyKey = "EUR" | "USD" | "MXN" | "COP" | "BRL" | "PEN";

export const CurrencyBadge: Record<CurrencyKey, string> = {
  EUR: "€",
  USD: "$",
  MXN: "$",
  COP: "$",
  BRL: "R$",
  PEN: "S/.",
};

interface CurrencyValue {
  decimals: number;
}
